(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8421],{

/***/ 52583:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cauta/[[...filters]]",
      function () {
        return __webpack_require__(34906);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26209);
/* harmony import */ var _components_withRouterPageLayout_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61167);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11752);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24461);
/* harmony import */ var _store_catalog_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35493);
/* harmony import */ var _containers_Catalog_List__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12311);
/* harmony import */ var _lib_filterUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82594);
/* harmony import */ var _containers_ErrorPage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75720);
/* harmony import */ var _store_app_actions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27173);












function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_5__["default"])(), settings = ref.publicRuntimeConfig.settings;
var List = // TODO: MEGA FUCKING WARNING!!
// MAKE SURE TO KEEP THINGS IN SYNC AT THE MOMENT
// cauta/[[...filters]].js
// [urlKey]/cpl/[[...filters]].js
/*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(List, Component1);
    var _super = _createSuper(List);
    function List(props) {
        _classCallCheck(this, List);
        var _this;
        _this = _super.call(this, props);
        _this.pageNamePrefix = "catalog";
        _this.state = {
            ready: false
        };
        return _this;
    }
    _createClass(List, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var query;
                    return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                query = _this.props.query;
                                if (!query.q) {
                                    _ctx.next = 9;
                                    break;
                                }
                                if (!_this.props.ready) {
                                    _ctx.next = 6;
                                    break;
                                }
                                {
                                    _this.setState({
                                        ready: true
                                    });
                                }
                                _ctx.next = 9;
                                break;
                            case 6:
                                _ctx.next = 8;
                                return _this.props.getSearch(query, _this.props.extractedFiltersParams);
                            case 8:
                                _this.setState({
                                    ready: true
                                });
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!this.state.ready && this.props.ready) {
                    this.setState({
                        ready: true
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, currentCategory = _props.currentCategory, extractedFiltersParams = _props.extractedFiltersParams, layout = _props.layout, query = _props.query, currentUrl = _props.currentUrl;
                if (!this.state.ready && query.q) {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        height: 100
                    }));
                }
                if (currentCategory && (currentCategory.category || currentCategory.search)) {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_Catalog_List__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            extractedFiltersParams: extractedFiltersParams,
                            layout: layout,
                            query: query,
                            currentUrl: currentUrl
                        })
                    }));
                }
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_ErrorPage__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    layout: "404"
                }));
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(ctx) {
                return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var reduxStore, query, urlAsPath, req, res, ready, currentUrl, queryFilters, filterPrefixIndex, extractedFiltersParams, categoryProducts;
                    return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                reduxStore = ctx.reduxStore, query = ctx.query, urlAsPath = ctx.asPath, req = ctx.req, res = ctx.res;
                                ready = null;
                                currentUrl = urlAsPath;
                                if (req) {
                                    currentUrl = "".concat(settings.baseUrl).concat(urlAsPath);
                                }
                                if (reduxStore.getState().app.websiteAdminConfigs.featureFlagsWebsite) {
                                    _ctx.next = 7;
                                    break;
                                }
                                _ctx.next = 7;
                                return reduxStore.dispatch((0,_store_app_actions__WEBPACK_IMPORTED_MODULE_11__/* .getWebsiteAdminConfig */ .z5)({
                                    code: "featureFlagsWebsite"
                                }));
                            case 7:
                                queryFilters = query.filters || [];
                                filterPrefixIndex = queryFilters.findIndex(function(queryFilter) {
                                    return queryFilter === "filtru";
                                });
                                if (filterPrefixIndex === 0) {
                                    queryFilters.shift();
                                }
                                extractedFiltersParams = (0,_lib_filterUtil__WEBPACK_IMPORTED_MODULE_9__/* .extractFiltersParams */ .Nl)(queryFilters);
                                if (query.exclude_preselected) {
                                    extractedFiltersParams.excludePreselected = query.exclude_preselected.split(",");
                                }
                                // Set the default number of items to bring
                                extractedFiltersParams.apiQueryParams = extractedFiltersParams.apiQueryParams + (extractedFiltersParams.apiQueryParams === "" ? "?" : "&") + "size=48";
                                if (!query.categories) {
                                    _ctx.next = 18;
                                    break;
                                }
                                _ctx.next = 16;
                                return reduxStore.dispatch((0,_store_catalog_actions__WEBPACK_IMPORTED_MODULE_7__/* .getCategory */ .n3)(query, extractedFiltersParams));
                            case 16:
                                categoryProducts = _ctx.sent;
                                if (!categoryProducts && res) {
                                    res.statusCode = 404;
                                }
                            case 18:
                                if (!(query.q && !req)) {
                                    _ctx.next = 22;
                                    break;
                                }
                                _ctx.next = 21;
                                return reduxStore.dispatch((0,_store_catalog_actions__WEBPACK_IMPORTED_MODULE_7__/* .getSearch */ .on)(query, extractedFiltersParams));
                            case 21:
                                ready = true;
                            case 22:
                                return _ctx.abrupt("return", {
                                    urlAsPath: urlAsPath,
                                    extractedFiltersParams: extractedFiltersParams,
                                    layout: query.q ? "search" : "category",
                                    query: query,
                                    ready: ready,
                                    currentUrl: currentUrl
                                });
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return List;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
List.pageLayout = "default";
/* harmony default export */ __webpack_exports__["default"] = ((0,_components_withRouterPageLayout_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(function(state) {
    return {
        user: state.user,
        currentCategory: state.catalog.currentCategory
    };
}, {
    getCategory: _store_catalog_actions__WEBPACK_IMPORTED_MODULE_7__/* .getCategory */ .n3,
    getSearch: _store_catalog_actions__WEBPACK_IMPORTED_MODULE_7__/* .getSearch */ .on
})(List)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1423,5866,1961,1458,4997,2311,9774,2888,179], function() { return __webpack_exec__(52583); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);